<!--
    描述：会议室管理  -- 编辑页
    时间： 2020/9/30
    Created by zl
-->
<template>
	<div class="filed-info-layout">
		<div class="common-top" ref="formRef">
			<el-form label-width="140px" :model="msgForm">
				<el-row class="addView">
					<el-col :span="12">
						<el-form-item prop="sname" label="场地名称：">
							<span>{{ adressObj.sname }}</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="addView">
					<el-col :span="12">
						<el-form-item prop="unit" label="场地所属单位：">
							<span>{{ adressObj.tenantSname }}</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="addView">
					<el-col :span="12">
						<el-form-item label="场地地址：" prop="address">
							<span>{{ adressObj.detailAdd }}-{{ adressObj.address }}</span>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<el-divider content-position="left">会议室信息</el-divider>

			<div class="add-area">
				<div class="add-box">
					<el-form label-width="140px" :model="meetingForm" :rules="meetingRule" ref="editMeeting">
						<el-row>
							<el-col>
								<el-form-item label="会议室名称：" prop="sname">
									<el-input
										v-model="meetingForm.sname"
										:disabled="disabled"
										placeholder="请输入会议室名称"
										@blur="checkName(meetingForm.sname)"
										maxlength="6"
										show-word-limit
									>
									</el-input>
								</el-form-item>
							</el-col>
							<el-col>
								<el-form-item label="会议室类型：" prop="type">
									<el-checkbox-group v-model="meetingForm.type" v-if="meetingForm.type" :disabled="disabled">
										<el-checkbox v-for="(item, index) in hyslx" :key="'hyslx' + index" :label="item.value">{{
											item.sname
										}}</el-checkbox>
									</el-checkbox-group>
								</el-form-item>
							</el-col>
							<el-col>
								<el-form-item label="场地容纳人数：" prop="galleryful">
									<el-input
										placeholder="请输入场地容纳人数"
										type="number"
										:disabled="disabled"
										v-model="meetingForm.galleryful"
										v-input-filter:int
										@keyup.native="meetingForm.galleryful = person(meetingForm.galleryful)"
									>
									</el-input>
								</el-form-item>
							</el-col>
							<el-col>
								<el-form-item label="会议室价格：" prop="price">
									<el-input
										:disabled="disabled"
										v-model="meetingForm.price"
										v-input-filter:price
										maxlength="12"
										@keyup.native="meetingForm.price = oninput(meetingForm.price)"
									>
										<template slot="append">元/天</template>
									</el-input>
								</el-form-item>
							</el-col>
							<el-col>
								<el-form-item label="会议室面积：" prop="area">
									<el-input
										v-model="meetingForm.area"
										:disabled="disabled"
										v-input-filter:price
										maxlength="12"
										@keyup.native="meetingForm.area = oninput(meetingForm.area)"
									>
										<template slot="append">平方米</template>
									</el-input>
								</el-form-item>
							</el-col>
							<el-col>
								<el-form-item label="会议室配置信息：" prop="configuration">
									<el-checkbox-group v-model="meetingForm.configuration" v-if="meetingForm.configuration" :disabled="disabled">
										<el-checkbox
											v-for="(item, index) in hyspzxx"
											:key="'hyspzxx' + index"
											:value="item.value"
											:label="item.value"
											>{{ item.sname }}</el-checkbox
										>
									</el-checkbox-group>
								</el-form-item>
							</el-col>
							<el-col>
								<el-form-item label="计算机mac白名单">
									<el-radio-group v-model="meetingForm.macOpen">
										<el-radio :label="0" :disabled="disabled">关闭</el-radio>
										<el-radio :label="1" :disabled="disabled">启用</el-radio>
									</el-radio-group>
									<el-input
										v-model="meetingForm.macs"
										placeholder="请输入白名单mac，多个计算机请以 ; 隔开"
										:disabled="meetingForm.macOpen == 0 || disabled"
									></el-input>
								</el-form-item>
							</el-col>
							<el-col>
								<el-form-item label="场地照片：">
									<public-upload
										ref="imgUpload"
										listType="picture-card"
										tableName="operate_meeting"
										assortment="operate_meeting"
										:aid="mId"
										:mode="disabled ? 'view' : ''"
										:acceptType="acceptArr"
										:needRefresh="false"
										:hoverImg="true"
										:maxNum="4"
									></public-upload>
									<p class="tips">最多上传四张图片</p>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>
			</div>
			<div class="foot-btn" :class="{ hidden: adressObj.tag == '1001002' }">
				<el-button size="small" icon="el-icon-edit-outline" @click="submitForm">保存</el-button>
			</div>
		</div>
	</div>
</template>
<script>
import { mapState } from 'vuex'
import { operMeetingEcho, saveOrUpdateOperateMeeting } from 'api/modules/fieldManagement'
export default {
	components: {},
	props: {
		mId: {
			type: String,
			default: ''
		},
		sId: {
			type: String,
			default: ''
		},
		adressObj: {
			type: Object,
			default: () => ({})
		},
		companyId: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			msgForm: {}, //场地信息
			meetingForm: {}, //会议室信息
			baseCheck: [],
			typeList: [],
			acceptArr: ['gif', 'jpg', 'jpeg', 'png', 'bmp', 'GIF', 'JPG', 'PNG'],
			yyxt: [
				{ sname: '安招采', value: '1017001' },
				{ sname: '经营', value: '1017002' },
				{ sname: '实施', value: '1017003' },
				{ sname: '办公OA', value: '1017004' }
			],
			meetingRule: {
				sname: [
					{
						required: true,
						message: '会议室名称不能为空',
						trigger: 'blur'
					}
				],
				type: [
					{
						required: true,
						message: '会议室类型不能为空',
						trigger: 'change'
					}
				],
				galleryful: [
					{
						required: true,
						message: '容纳人数不能为空',
						trigger: 'blur'
					}
				],
				price: [
					{
						required: true,
						message: '会议室价格不能为空',
						trigger: 'blur'
					}
				],
				configuration: [
					{
						required: true,
						message: '会议室配置不能为空',
						trigger: 'change'
					}
				],
				area: [
					{
						required: true,
						message: '会议室面积不能为空',
						trigger: 'blur'
					}
				]
			}
		}
	},
	created() {
		this.mId != '' ? this.getMeetingInfo() : this.goBack()
	},
	methods: {
		// 获取会议室信息
		getMeetingInfo() {
			operMeetingEcho({
				id: this.mId
			}).then((d) => {
				if (d.code == 0) {
					this.meetingForm = d.data
					this.$nextTick(() => {
						this.meetingForm.configuration = d.data.configuration.split(',')
						this.meetingForm.type = d.data.type.split(',')
					})
				}
			})
		},

		// 返回
		goBack() {
			if (this.routeQuery == 'edit') {
				this.$router.push({ path: '/room-management' })
			} else if (this.routeQuery == 'detail') {
				// this.$router.push({ path: '/field-management' })
				setTimeout(() => {
					this.$router.push({
						name: 'Field-management',
						params: { id: this.companyId },
						query: {
							type: 'Area'
						}
					})
				}, 1000)
			}
		},

		// 保存编辑
		submitForm() {
			this.$refs.editMeeting.validate((valid) => {
				if (valid) {
					let operateMeetingList = Object.assign({}, this.meetingForm)
					operateMeetingList.configuration = operateMeetingList.configuration.join(',')
					operateMeetingList.type = operateMeetingList.type.join(',')
					saveOrUpdateOperateMeeting({
						id: this.sId,
						operateMeetingList: {
							id: this.mId,
							siteId: this.sId,
							sname: operateMeetingList.sname,
							type: operateMeetingList.type,
							isFlag: 1,
							galleryful: operateMeetingList.galleryful,
							price: operateMeetingList.price,
							configuration: operateMeetingList.configuration,
							area: operateMeetingList.area,
							macOpen: operateMeetingList.macOpen,
							macs: operateMeetingList.macs,
							newFlag: '1'
						}
					}).then((d) => {
						if (d.code == 0) {
							this.$message.success('编辑成功！')
							this.$emit('on-reset')
							this.goBack()
						}
					})
				} else {
					this.$message.warning('请完善表单！')
				}
			})
		},

		// 校验金额
		oninput(num) {
			let str = num.toString()
			let len1 = str.substr(0, 1)
			let len2 = str.substr(1, 1)
			//如果第一位是0，第二位不是点，就用数字把点替换掉
			if (str.length > 1 && len1 == 0 && len2 != '.') {
				str = str.substr(1, 1)
			}
			//第一位不能是.
			if (len1 == '.') {
				str = ''
			}
			//限制只能输入一个小数点
			if (str.indexOf('.') != -1) {
				var str_ = str.substr(str.indexOf('.') + 1)
				if (str_.indexOf('.') != -1) {
					str = str.substr(0, str.indexOf('.') + str_.indexOf('.') + 1)
				}
			}
			//正则替换
			str = str.replace(/[^\d^\.]+/g, '') // 保留数字和小数点
			// str = str.replace(/\.\d\d\d$/, '') // 小数点后只能输两位
			return parseFloat(str)
		},

		person(num) {
			if (num != '') {
				let str = num.toString()
				str = str.replace(/[^\.\d]/g, '')
				str = str.replace('.', '')
				if (str.length > 9) {
					str = str.substr(0, 9)
					this.$message.warning('最长9位')
					return parseInt(str)
				}
				return parseInt(str)
			} else {
				return ''
			}
		},

		// 校验会议室名称
		checkName(data) {
			data = data.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g, '')
			this.meetingForm.sname = data
		}
	},
	computed: {
		...mapState('place_dict', { hyslx: (state) => state.hyslx }),
		...mapState('place_dict', { hyspzxx: (state) => state.hyspzxx }),
		routeQuery() {
			return this.$route.query.type
		},
		disabled() {
			return this.adressObj.tag == '1001002'
		}
	}
}
</script>
<style lang="less" scoped>
.filed-info-layout {
	height: 100%;
	background-color: #fff;
	.common-top {
		padding: 5px 20px 20px 20px;
		background-color: #fff;
		.special-item {
			/deep/ .el-form-item__content {
				display: flex;
				flex-wrap: wrap;
				justify-content: space-around;
			}
			/deep/ .el-select {
				flex: 1;
				width: 33.3%;
			}
			/deep/ .el-select + .el-select {
				margin-left: 15px;
			}
			.detail-msg {
				margin-top: 15px !important;
			}
		}
	}
	.el-icon-circle-plus {
		font-size: 30px;
		color: #009900;
		cursor: pointer;
	}
	.add-meeting {
		color: #256ccb;
		font-size: 12px;
		margin-left: 10px;
		cursor: pointer;
	}
	.add-area {
		.add-box {
			width: 60%;
			padding: 0px 20px 0px 0;
			position: relative;
		}
		.del-btn {
			position: absolute;
			cursor: pointer;
			background-color: #dcdfe6;
		}
	}
	.foot-btn {
		position: absolute;
		top: 88px;
		right: 135px;
		.el-button {
			height: 28px !important;
		}
	}
	/deep/ .el-input-group__append {
		background-color: #256ccb;
		color: #fff;
	}
	.addView {
		/deep/ .el-form-item {
			margin-bottom: 0 !important;
		}
	}
	.tips {
		font-size: 12px;
		color: #606266;
		height: 20px;
		line-height: 20px;
	}
}
</style>
